import ThumbNailsMini, { ThumbNail } from '../ThumbNailsMini/ThumbNailsMini';

import styles from './ThumbNailMiniLists.module.css';

interface Props {
  thumbs: ThumbNail[];
}

export default function ThumbNailMiniLists({ thumbs }: Props) {
  return (
    <div className={styles.grid}>
      {thumbs.map((thumb) => {
        const { id, title, slug, src } = thumb;

        return <ThumbNailsMini key={id} src={src} slug={slug} alt={title} />;
      })}
    </div>
  );
}
